export var ButtonTypeEnum;
(function (ButtonTypeEnum) {
    ButtonTypeEnum["CHECK_ANSWER"] = "Check_Answer";
    ButtonTypeEnum["CONTINUE"] = "Continue";
    ButtonTypeEnum["SUBMIT"] = "Submit";
    ButtonTypeEnum["TRY_AGAIN"] = "Try Again";
})(ButtonTypeEnum || (ButtonTypeEnum = {}));
